import React from 'react';
import styled from '@emotion/styled';

const MessageWrapper = styled.div`
  & div[data-testid='yellow-message'] {
    background-color: #ffefd3;
    border-radius: 0 0 0 var(--Unit-32, 32px);
  }
`;
export const YellowMessage = props => {
  const { children } = props;
  return <MessageWrapper>{children}</MessageWrapper>;
};
